import { render, staticRenderFns } from "./dyxx_add.vue?vue&type=template&id=307f94f5&"
import script from "./dyxx_add.vue?vue&type=script&lang=js&"
export * from "./dyxx_add.vue?vue&type=script&lang=js&"
import style0 from "./dyxx_add.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports